import script from "./FileSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./FileSelector.vue?vue&type=script&setup=true&lang=js"

import "./FileSelector.vue?vue&type=style&index=0&id=09f3c5e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f3c5e4"]])

export default __exports__